import React from 'react';
import { getCurrentUser, editUserDetails } from '../epics-users';
import { Link, withRouter } from 'react-router-dom';
import { StaticRoutePaths } from '../../Common/ClientRoutes';
import Svgs from '../../Common/Svgs';
import { FormRow, Input, MainBtn, CancelBtn } from '../../Common/form/Elements-export';

class UserDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingSpinner: false,
            userId: '',
            username: '',
            email: '',
            phone: '',

            validation: {
                username: '',
                email: '',
                phone: ''
            }
        };
    }

    componentDidMount() {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });
        getCurrentUser()
            .then(resposne => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    userId: resposne.id,
                    username: resposne.names,
                    email: resposne.email,
                    phone: resposne.phone
                });
            })
            .catch(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    userId: '',
                    username: '',
                    email: '',
                    phone: ''
                });
            });
    }

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    saveUserDetailsHandler = (id, details) => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });

        editUserDetails(id, details)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                this.props.history.push(StaticRoutePaths.INFO_USER);
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    validation: {
                        ...this.state.validation,
                        username:
                            this.generateErrorMessage(error.body, 'names')
                                .join(' ')
                                .trim() || '',
                        email:
                            this.generateErrorMessage(error.body, 'email')
                                .join(' ')
                                .trim() || '',
                        phone:
                            this.generateErrorMessage(error.body, 'phone')
                                .join(' ')
                                .trim() || ''
                    }
                });
            });
    };

    cancelUserHandler = () => {
        this.props.history.push(StaticRoutePaths.INFO_USER);
    };

    generateErrorMessage = (errArray, errName) => {
        if (errArray !== null) {
            return (errArray || []).map(singleErr => {
                return singleErr.property_path === errName ? singleErr.message : '';
            });
        }
    };

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.users}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-pencil-square mr-2" />User Details
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.INFO_USER} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />Back
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>
                        {this.state.loadingSpinner ? (
                            <div className="col-11 white-bg px-5 text-center p-3">
                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                            </div>
                        ) : (
                            <div className="form-wrapper">
                                <FormRow>
                                    <Input
                                        label="* Name"
                                        type="text"
                                        handler={this.update('username')}
                                        placeholder="User Full name"
                                        value={this.state.username ? this.state.username : ''}
                                        extraClasses="col-12"
                                    />
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.username)}</div>
                                </FormRow>
                                <FormRow>
                                    <Input
                                        label="* Email"
                                        type="text"
                                        handler={this.update('email')}
                                        placeholder="This is just for verification and login"
                                        value={this.state.email ? this.state.email : ''}
                                        extraClasses="col-12"
                                    />
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.email)}</div>
                                </FormRow>
                                <FormRow>
                                    <Input
                                        label="* Phone"
                                        type="text"
                                        handler={this.update('phone')}
                                        placeholder="Work phone"
                                        value={this.state.phone ? this.state.phone : ''}
                                        extraClasses="col-12"
                                    />
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.phone)}</div>
                                </FormRow>
                                <FormRow>
                                    <div className="col-2 offset-8 qf-mb-30">
                                        {this.state.loadingSpinner ? (
                                            <div className="px-5 text-center p-3" />
                                        ) : (
                                            <CancelBtn
                                                onclick={this.cancelUserHandler}
                                                title="Cancel"
                                                extraClasses="qf-gray-btn w-100 mt-4"
                                            />
                                        )}
                                    </div>

                                    <div className="col-2 qf-mb-30">
                                        {this.state.loadingSpinner ? (
                                            <div className="col-11 white-bg px-5 text-center p-3">
                                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                            </div>
                                        ) : (
                                            <MainBtn
                                                onclick={() => this.saveUserDetailsHandler(this.state.userId, this.state)}
                                                title="Save"
                                                extraClasses="qf-blue-btn w-100 mt-4"
                                            />
                                        )}
                                    </div>
                                </FormRow>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(UserDetails);



// WEBPACK FOOTER //
// ./src/customModules/Users/components/User-details-form.js